import React, {useCallback, useEffect} from "react";
import CommonTitle from "../../components/common-title";
import Input from "../../components/inputItem";
import useForm from "rc-form-hooks";
import {useLoading} from "../../components/loading/LoadingProvider";
import {postUserIdentity, postUserNameModify} from "../../service";
import useUserInfo from "../../routers/useUserInfo";

type Props = {
    onSuccess:() => void
}

const PaymentInfoConfirm:React.FC<Props> = (props) => {

    const {getFieldDecorator, validateFields, errors, values} = useForm<{
        name: string,
        identity:string
    }>();

    const userData = useUserInfo(false);

    const loading = useLoading()

    useEffect(() => {
       if(userData && userData.fullName && userData.idNumber){
           props.onSuccess()
       }
    },[])

    const handleSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();
        validateFields()
            .then(res => {
                if (userData && typeof values.name === 'string' && typeof values.identity === 'string') {
                    loading.showLoading()
                    Promise.all([
                        postUserNameModify({
                            userId: userData.id,
                            name: values.name
                        }),
                        postUserIdentity({
                            userId: userData.id,
                            identity: values.identity
                        })
                    ]).then((values) => {
                        const _values = values.filter((item) => item.code === 1 )
                        if(_values.length === 2){
                            loading.showSuccess('提交成功',() => {
                                props.onSuccess()
                            })
                        }
                    })
                }

            })
    }, [values])

    return <div className="payment-info">
       <div className="box">
           <CommonTitle title={'个人信息完善'}/>
           <div className="content">
               <p>BG联盟会员认证需要先确认您的个人身份信息，避免被他人盗用。BG联盟不会向其他第三方机构泄露您的个人信息。</p>
           </div>
       </div>
        <div className="box">
            <form onSubmit={handleSubmit}>
                {
                    getFieldDecorator('name', {
                        rules: [{required: true, message: '请输入真实姓名'}],
                        initialValue: userData?.fullName
                    })(<Input label='真实姓名' type={'text'} placeholder='请输入真实姓名'
                              extraClass={['no-border-top', 'fill-width']}
                              clear/>)
                }
                {
                    getFieldDecorator('identity', {
                        rules: [{required: true, message: '请输入身份证号'}],
                        initialValue: userData?.idNumber
                    })(<Input label='身份证号' type={'text'} placeholder='请输入身份证号'
                              extraClass={['no-border-top', 'fill-width']}
                              clear/>)
                }
                {
                    userData && <button type={'submit'} className="common-btn submit">确认</button>
                }

            </form>
        </div>
    </div>
}

export default PaymentInfoConfirm
